import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-popup-shared',
  templateUrl: './popup-shared.component.html',
  styleUrls: ['./popup-shared.component.scss']
})
export class PopupSharedComponent  {
  constructor(
    private router: Router,
    private dialogRef: MatDialogRef<PopupSharedComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}


  eventShared(event: string){
    const url = window.location.href;
    // const url = 'https://wvleiloes.com/';

    if(event === 'wpp')this.compartilharNoWhatsApp(url)
    if(event === 'face')this.compartilharNoFacebook(url)
    if(event === 'twitter')this.compartilharNoTwitter(url)
    if(event === 'linkedin')this.compartilharNoLinkedIn(url)
    if(event === 'shared')this.compartilharNoMobile(url)
    if(event === 'copy')this.copiarLink(url)
  }

  compartilharNoFacebook(url: string) {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '_blank');
  }

  compartilharNoWhatsApp(url: string) {
    window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(url)}`, '_blank');
  }

  compartilharNoTwitter(url: string) {
    const textoDoTweet = 'Confira este link:';
    const tweetUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(textoDoTweet)}&url=${encodeURIComponent(url)}`;
    window.open(tweetUrl, '_blank');
  }

  compartilharNoLinkedIn(url: string) {
    const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
    window.open(linkedinUrl, '_blank');
  }

  compartilharNoMobile(url: string) {
    if (navigator.share !== undefined) {
      navigator.share({
        title: document.title,
        text: 'Confira este link:',
        url: url
      })
      .then(() => console.log('Successful share'))
      .catch((error) => console.log('Error sharing', error));
    }
  }

  copiarLink(url: string) {
    navigator.clipboard.writeText(url).then(() => {
      alert('Link copiado para a área de transferência.');
    }).catch((error) => {
      console.error('Erro ao copiar o link: ', error);
    });
  }
}
